import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare const grecaptcha: any;

const RECAPTCHA_SITE_KEY = environment.recaptcha_token;

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  private scriptLoadedPromise: Promise<void> | null = null;

  /**
   * Muat script Google reCAPTCHA v3 secara dinamis berdasarkan environment.
   */
  loadScript(): Promise<void> {
    if (this.scriptLoadedPromise) {
      return this.scriptLoadedPromise;
    }

    this.scriptLoadedPromise = new Promise<void>((resolve, reject) => {
      if (typeof grecaptcha !== 'undefined') {
        resolve();
        return;
      }

      const existingScript = document.getElementById('recaptcha-script') as HTMLScriptElement | null;
      if (existingScript) {
        existingScript.addEventListener('load', () => resolve());
        existingScript.addEventListener('error', (err) => reject(err));
        return;
      }

      const script = document.createElement('script');
      script.id = 'recaptcha-script';
      script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = (err) => {
        this.scriptLoadedPromise = null;
        reject(err);
      };
      document.head.appendChild(script);
    });

    return this.scriptLoadedPromise;
  }

  /**
   * Eksekusi reCAPTCHA v3 dan kembalikan token.
   * @param action - nama aksi (misal: 'login', 'register', 'forgot_password')
   * @returns Promise<string> token reCAPTCHA
   */
  execute(action: string): Promise<string> {
    return this.loadScript().then(
      () =>
        new Promise((resolve, reject) => {
          if (typeof grecaptcha === 'undefined') {
            reject('grecaptcha is not loaded');
            return;
          }
          grecaptcha.ready(() => {
            grecaptcha
              .execute(RECAPTCHA_SITE_KEY, { action })
              .then((token: string) => resolve(token))
              .catch((err: any) => {
                console.error('reCAPTCHA execute error:', err);
                reject(err);
              });
          });
        })
    );
  }
}
